// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sort.default[data-v-2f33a48c] {\n  color: lightgray;\n}", ""]);
// Exports
module.exports = exports;
